module.exports = __webpack_public_path__ + "static/media/auction.40612656.svg";